import { FeatureFlag } from '../FeatureFlag';

export const enableLabPoolManagement = new FeatureFlag({
    key: 'enable-lab-pool-management',
    createdOn: '2026-05-18',
    defaultValue: true,
});
